import { useMemo, } from 'react';
import moment from 'moment-timezone';
import { Schedule } from 'utils/type'; // Assuming you have Schedule type defined in 'utils/type'
import { BackendDateFormat } from 'utils/constants';

const useNextSchedule = (
  schedules: Schedule[] = [],
  doctorId: number | string,
  date: moment.Moment,
  startedDateTime:string,
  skipHours:number,
  duration:number
): moment.Moment| null => {
  const matchedScheduleDate = useMemo(() => {
    let nextScheduleDate: moment.Moment | null = null; // Track the next schedule date found
    const startDateTime = moment.parseZone(startedDateTime,BackendDateFormat)
    // Iterate through schedules to find the next valid schedule
    for (let schedule of schedules) {
      // Parse the doctor IDs
      const doctorIds = Array.isArray(schedule.sch_doctor_ids)
        ? schedule.sch_doctor_ids.map(String)
        : [String(schedule.sch_doctor_ids)];

      // Check if the given doctor ID is present in the parsed doctor IDs
      if (doctorIds.includes(String(doctorId))) {
        const checkinDate = moment.parseZone(schedule.checkin_time,BackendDateFormat);
        const checkoutDate = moment.parseZone(schedule.checkout_time,BackendDateFormat);
        const schecduleEndDateTime = moment.parseZone(schedule.checkout_time,BackendDateFormat).clone()
        .subtract(skipHours,"hours")
        .subtract(duration,"minutes");

        // Function to match the date with the given date
        const matchesDate = (momentDate: moment.Moment, date: moment.Moment) => {
          return (
            momentDate.isSame(date, 'day')
          );
        };

        // Check if the given date matches checkin date or checkout date or if it's before the checkout date
        if (matchesDate(checkinDate, date) || matchesDate(checkoutDate, date) || checkinDate.isAfter(date)) {
          // Determine if this schedule date is the next valid one
          const currentScheduleDate = checkinDate.isSameOrAfter(date) ? checkinDate : checkoutDate;
          
          // If no nextScheduleDate is set or currentScheduleDate is earlier than nextScheduleDate, update it
          if ((!nextScheduleDate || currentScheduleDate.isBefore(nextScheduleDate)) && schecduleEndDateTime.isAfter(startDateTime)) {
            nextScheduleDate = currentScheduleDate;
          }
        }
      }
    }
    return nextScheduleDate||null ; // Return the found next schedule date or "notFound" if none found
  }, [schedules, doctorId, date]);

  return matchedScheduleDate;
};

export default useNextSchedule;